// extracted by mini-css-extract-plugin
export var Choices = "styles-module--Choices--r3Qlu";
export var Choice_Input = "styles-module--Choice_Input--2us63";
export var Choice_Label = "styles-module--Choice_Label--1xXUP";
export var Choice_Label_Checked = "styles-module--Choice_Label_Checked--99yuC";